import React from "react"

import { useDisableOverflowBehavior } from "~utils/use-disable-overflow-behavior"
import { useSearchInputFromUrl } from "~utils/url-param-helpers"
import { SearchProvider } from "~components/providers/search-provider"
import SearchContent from "~components/pages/search/search-content"

export default function Search() {
    useDisableOverflowBehavior()
    const searchInput = useSearchInputFromUrl()

    return (
        <SearchProvider searchInput={searchInput}>
            <SearchContent />
        </SearchProvider>
    )
}
